import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import BroadbandContentCarousel from '../../eir-broadband/BroadbandContentCarousel';
import FaqContainer from '../../eir-mobile-broadband/FaqContainer';
import EirInformation from '../../eir-information/EirInformation';
import PrepayMobileOfferToggle from './PrepayMobileOfferToggle';
import PrepayMobileOfferContainer from './PrepayMobileOfferContainer';
import { PrepayOfferContext } from './prepay.context';
import styles from './styles';

/**
 * @name PrepayMobileContainer - Prepay Mobile Container component
 * @param {*} props - Strapi cms data
 * @returns {JSX.Element} - Returns Prepay Mobile Container Element
 */
const PrepayMobileContainer = ({ cmsData = {} }) => {
  const theme = useTheme();
  const style = styles(theme);
  const [state, setState] = useState({ prepaySIM: true });

  return (
    <PrepayOfferContext.Provider value={{ state, setState }}>
      <Grid container sx={{ flexDirection: 'column' }}>
        <EirInformation
          title={
            state?.prepaySIM
              ? cmsData?.attributes?.eirInformationSIM?.title
              : cmsData?.attributes?.eirInformationSimAndPhone?.title
          }
          description={
            state?.prepaySIM
              ? cmsData?.attributes?.eirInformationSIM?.description
              : cmsData?.attributes?.eirInformationSimAndPhone?.description
          }
          textAlign={
            state?.prepaySIM
              ? cmsData?.attributes?.eirInformationSIM?.textAlign
              : cmsData?.attributes?.eirInformationSimAndPhone?.textAlign
          }
          useH1={
            state?.prepaySIM
              ? cmsData?.attributes?.eirInformationSIM?.useH1
              : cmsData?.attributes?.eirInformationSimAndPhone?.useH1
          }
        />
        <PrepayMobileOfferToggle prepaySIM={state?.prepaySIM} />
        <PrepayMobileOfferContainer prepaySIM={state?.prepaySIM} />
        <Grid item xs={12} sx={{ background: theme.palette.secondary.contrastText }}>
          <BroadbandContentCarousel
            contentTitle={cmsData?.attributes?.contentTilesHeading?.title}
            contentDescription={cmsData?.attributes?.contentTilesHeading?.description}
            contentCarousel={cmsData?.attributes?.contentTiles}
            useH1={cmsData?.attributes?.contentTilesHeading?.useH1}
          />
        </Grid>
        {cmsData?.attributes?.mobileFaqList?.length > 0 && (
          <Grid item xs={12} sx={style.faqContainerSuperMain}>
            <FaqContainer
              InsuranceHeading={cmsData?.attributes?.mobileFaqTitle}
              InsuranceList={cmsData?.attributes?.mobileFaqList}
            />
          </Grid>
        )}
      </Grid>
    </PrepayOfferContext.Provider>
  );
};
PrepayMobileContainer.displayName = 'PrepayMobileContainer';
export default PrepayMobileContainer;
